import { render, staticRenderFns } from "./NewStockOrder.vue?vue&type=template&id=05f03b9c"
import script from "./NewStockOrder.vue?vue&type=script&lang=js"
export * from "./NewStockOrder.vue?vue&type=script&lang=js"
import style0 from "./NewStockOrder.vue?vue&type=style&index=0&id=05f03b9c&prod&lang=css"
import style1 from "./NewStockOrder.vue?vue&type=style&index=1&id=05f03b9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports